import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getstudentFeedbackAPi, deletestudentFeedbackApi,updatefeedbackApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// get studentFeedback
export const getstudentFeedback = createAsyncThunk('getstudentFeedback/studentFeedback', async () => {
    try {
        const response = await axios.get(`${getstudentFeedbackAPi}?limit=`, { headers });
        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete studentFeedback
export const deletestudentFeedbacks = createAsyncThunk('deletestudentFeedbacks/studentFeedback', async (studentFeedbackid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletestudentFeedbackApi}/${studentFeedbackid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'studentFeedbackid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});
// delete studentFeedback
export const updatefeedback = createAsyncThunk('updatefeedback/studentFeedback', async ({ id, data }, { rejectWithValue }) => {
    try {
        const response = await axios.patch(`${updatefeedbackApi}/${id}`, data, { headers });
        return response.data._id; // Assuming your API response contains a 'studentFeedbackid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const studentFeedbackSlice = createSlice({
    name: 'studentFeedback',
    initialState: {
        studentFeedbacks: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //getstudentFeedbacks
            .addCase(getstudentFeedback.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getstudentFeedback.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.studentFeedbacks = action.payload;
            })
            .addCase(getstudentFeedback.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            //updatefeedback
            .addCase(updatefeedback.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatefeedback.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.studentFeedbacks.data = action.payload;
                state.status = 'idle';
            })
            .addCase(updatefeedback.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete studentFeedbacks
            .addCase(deletestudentFeedbacks.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletestudentFeedbacks.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.studentFeedbacks.data = state.studentFeedbacks.data.filter(studentFeedbacks => studentFeedbacks.studentFeedbackid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletestudentFeedbacks.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default studentFeedbackSlice.reducer;
